exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n.home {\n  padding: 1rem;\n  text-align: center;\n}\n.jumbotron {\n  padding: 1rem 0.5rem !important;\n}\n.url-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n}\n.spec {\n  font-size: 0.8125rem !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/html/mediate/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/html/mediate/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/html/mediate/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles